import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFacetAccordionItem } from '#/modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from '#/modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from '#/modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import {
  SEARCH_JOB_REFINEMENT_LABELS,
  SearchJobRefinement,
} from '#/modules/search/constants/refinements/searchJobsRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { EMPLOYMENT_TYPE_CHECKBOX_OPTIONS } from '#/utils/constants/general/employmentTypes';

type Props = {
  variant: SearchRefinementVariant;
};
export function EmploymentTypeFacet({ variant }: Props) {
  const { i18n } = useI18n();

  const selectedFacetValues = useSearchFacetSelectedValues(
    SearchJobRefinement.JOB_TYPE,
  );

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType={SearchJobRefinement.JOB_TYPE}
      icon="hammer"
      label={
        <>
          {SEARCH_JOB_REFINEMENT_LABELS(i18n).jobType}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType={SearchJobRefinement.JOB_TYPE}
        initialValue={selectedFacetValues}
        options={EMPLOYMENT_TYPE_CHECKBOX_OPTIONS(i18n)}
      />
    </FacetVariant>
  );
}
